/**
 * @Description: 装修分类
 * @Author Jiang
 * @Date 2020/8/13 17:53
 */
import React, {Component} from "react";
import {Button, Card, Input, message, Radio, Row, Select} from "antd";
import './index.less'
import TextArea from "antd/es/input/TextArea";
import ArrowLeftOutlined from "@ant-design/icons/lib/icons/ArrowLeftOutlined";
import {getRemodelCategorySave, getRemodelCategoryInfo} from "../../../../constants/api";
import {removeToken} from "../../../../utils/cookie";

import {COMMON_ROUTER} from "../../../../constants";

export default class Feature extends Component {
  constructor(props) {
    super(props);

    this.state = {
      panes: [],
      category: [
          {
            decorationCategoryId:null,
            decorationShopCategoryId:0,
            categoryType:"HOT",
            categoryName:"热销",
            categoryDesc:"",
            categoryStatus:"SHOW",
            categorySortType:"DEFAULT_SORT",
            shopId:0,
            templateId:'',
            dataStatus:0,
            createTime:"",
            updateTime:""},
        {
          decorationCategoryId:null,
          decorationShopCategoryId:0,
          categoryType:"DISCOUNT",
          categoryName:"优惠",
          categoryDesc:"",
          categoryStatus:"HIDE",
          categorySortType:"DEFAULT_SORT",
          shopId:0,
          templateId:'',
          dataStatus:0,
          createTime:"",
          updateTime:""
        }
        ], //分类信息
      templateId: '',
      shopId: '',
    };
    this.rank = [
      {label: "默认排序", value: "DEFAULT_SORT"},
      {label: "价格从高到低", value: "PRICE_DESC"},
      {label: "价格从低到高", value: "PRICE_ASC"},
      {label: "销量从高到低", value: "SALES_VOLUME_DESC"},
      {label: "默认排序销量从低到高", value: "SALES_VOLUME_ASC"},
    ]
    this.status = [
      {label: "开启", value: "SHOW"},
      {label: "关闭", value: "HIDE"},
    ]
  }

  onChange = activeKey => {
    this.setState({activeKey});
  };

  componentWillMount() {
    if (this.props.location.state) {
      this.setState({
        templateId: this.props.location.state.templateId,
        shopId: this.props.location.state.shopId
      })
    }
  }

  componentDidMount() {
    this.getTemplateId()
    // this.getCategory()
  }

  getTemplateId = () => {
    let storage = window.localStorage;
    let templateId = storage.getItem('templateId');
    let platformType = storage.getItem('platformType')
    if (templateId && platformType) {
      this.setState({
        templateId: templateId,
        platformType: platformType
      }, () => {
        this.getCategory(templateId, platformType)
      })
    } else {
      message.error('请先选择总店', 1)
    }
  }

  /**
   * @Description: 获取分类
   * @Author Jiang
   * @Date 2020/8/14 8:08
   */
  getCategory(templateId, platformType) {
    getRemodelCategoryInfo({
      shopId: this.state.shopId,
      templateId: templateId,
      platformType: platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          if (data.data.length === 2) {
            this.setState({
              category: data.data,
            })
          } else if (data.data.length === 0) {
          } else if (data.data.length === 1) {
            if (data.data[0].categoryType === 'HOT') {
              const categoryTemp = [...this.state.category]
              categoryTemp.splice(0, 1)
              categoryTemp.unshift(data.data[0])
              this.setState({
                category: categoryTemp,
              })
            } else {
              const categoryTemp = [...this.state.category]
              categoryTemp.splice(1, 1)
              categoryTemp.unshift(data.data[0])
              this.setState({
                category: categoryTemp,
              })
            }
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_CATEGORY, {
    //   // id: this.state.shopId,
    //   // id: 500815041,
    //   // id: this.state.templateId,
    //   shopId: this.state.shopId,
    //   templateId: templateId,
    //   platformType: platformType
    // }).then(res => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       if (data.data.length === 2) {
    //         this.setState({
    //           category: data.data,
    //         })
    //       } else if (data.data.length === 0) {
    //       } else if (data.data.length === 1) {
    //         if (data.data[0].categoryType === 'HOT') {
    //           const categoryTemp = [...this.state.category]
    //           categoryTemp.splice(0, 1)
    //           categoryTemp.unshift(data.data[0])
    //           this.setState({
    //             category: categoryTemp,
    //           })
    //         } else {
    //           const categoryTemp = [...this.state.category]
    //           categoryTemp.splice(1, 1)
    //           categoryTemp.unshift(data.data[0])
    //           this.setState({
    //             category: categoryTemp,
    //           })
    //         }
    //       }
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  /**
   * @Description: 处理各个值变化
   * @Author Jiang
   * @Date 2020/8/14 8:58
   */
  onHandleChange(type, index, e) {

    let category = this.state.category

    let pane = category[index]
    switch (type) {
      case 'status':
        pane.categoryStatus = e.target.value

        break;
      case 'name':
        pane.categoryName = e.target.value

        break;
      case "desc":
        pane.categoryDesc = e.target.value
        break;
      case "sort":
        pane.categorySortType = e
        break;
      default:
        break;
    }
    category[index] = pane
    this.setState({
      category: category,

    })
  }

  /**
   * @Description: 确认发布按钮
   * @Author Jiang
   * @Date 2020/8/14 9:49
   */
  submit(item) {
    getRemodelCategorySave({
      categoryDesc: item.categoryDesc,
      categoryName: item.categoryName,
      categorySortType: item.categorySortType,
      categoryStatus: item.categoryStatus,
      categoryType: item.categoryType,
      shopId: this.state.shopId,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.props.history.push(COMMON_ROUTER + '/shopRenovation')
          message.success('发布成功', 1)
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_CATEGORY_SAVE, {
    //   categoryDesc: item.categoryDesc,
    //   categoryName: item.categoryName,
    //   categorySortType: item.categorySortType,
    //   categoryStatus: item.categoryStatus,
    //   categoryType: item.categoryType,
    //   shopId: this.state.shopId,
    //   templateId: this.state.templateId
    // }).then(res => {
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       this.props.history.push(COMMON_ROUTER + '/shopRenovation')
    //       message.success('发布成功', 1)
    //     }else {
    //       message.error(data.msg,1)
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }
  /**
   * @Description: 取消
   * @Author Jiang
   * @Date 2020/8/17 14:00
   */
  cancel = () => {
    this.props.history.push(COMMON_ROUTER + '/shopRenovation')
  }


  render() {
    return (
      <Card style={{width: '100%'}} headStyle={{paddingLeft:'100px'}}  title={'特色分类'}>
          <Button style={{borderWidth:0,position:"absolute",top:'12px',left:'10px'}}  onClick={this.cancel.bind(this)}>
            <ArrowLeftOutlined />返回
      </Button>
        <Row justify='center'>
          {this.state.category.map((item, index) => {
            return <div style={{marginLeft: '40px'}}>
              <div>
                <Button>
                  {item.categoryName}
                </Button>
              </div>
              <div className='title'>
                <div>
                  分类状态
                </div>
                <div>
                  <Radio.Group className='select' value={item.categoryStatus}
                               onChange={this.onHandleChange.bind(this, 'status', index)}
                               options={this.status}
                  />
                </div>
              </div>
              {item.categoryStatus === "SHOW" ? <div>
                <div className='title'>
                  <div>
                    分类名称
                  </div>
                  <div>
                    <Input defaultValue={item.categoryName} onChange={this.onHandleChange.bind(this, 'name', index)}
                           style={{width: '400px', height: '40px', borderRadius: '12px', marginTop: '10px'}}/>
                  </div>
                </div>
                <div className='title'>
                  <div>
                    分类描述
                  </div>
                  <div>
                    <TextArea defaultValue={item.categoryDesc} onChange={this.onHandleChange.bind(this, 'desc', index)}
                              style={{width: '400px', height: '80px', borderRadius: '12px', marginTop: '10px'}}/>
                  </div>
                </div>
                <div className='title'>
                  <div>
                    排序方式
                  </div>
                  <div id='rank'>
                    <Select defaultValue={item.categorySortType}
                            onChange={this.onHandleChange.bind(this, 'sort', index)}
                            style={{width: "400px", borderRadius: "20px"}}
                            getPopupContainer={() => document.getElementById('rank')}>
                      {this.rank.map((classify, index) => {
                        return <Select.Option key={index}
                                              value={classify.value}>{classify.label}</Select.Option>
                      })}
                    </Select>
                  </div>
                </div>
              </div> : null}

              <div className='add' onClick={this.submit.bind(this, item)}>
                确认发布
              </div>
            </div>
          })}
        </Row>
      </Card>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/shopmanage/shoprenovation/feature/index.js